/**
 * @file packages/expo-squircle/src/index.ts
 * @description Package entry point for the Squircle View component exports.
 *
 * @license MIT. Copyright (c) Doğu Abaris.
 */

export { default } from './ExpoSquircle';
export { default as ExpoSquircle } from './ExpoSquircle';
export * from './ExpoSquircle.types';
